import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: build subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  // only tenant-admin OR if subTenantId is missing
  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const ReheatProcessApi = {
  // Create reheat process
  CreatereheatProcess: (data) => {
    const jsonData = JSON.parse(data);
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

    return apiApp
      .post(`/reheat-processes`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List reheat processes
  ListreheatProcess: (page, limit) => {
    const url = `/reheat-processes?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Get single reheat process
  SinglereheatProcess: (reheatProcessId) => {
    const url = `/reheat-processes/${reheatProcessId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`;
    return apiApp
      .get(url, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default ReheatProcessApi;
